import { Nullable } from "@core/domain/types/nullable.type";
import { injectable } from "inversify";
import { IvaExemptTypeEnum } from "@entity/domain/models/iva-exempt-type.model";
import { IvaExemptionTypeEnumDto } from "@entity/data/dto/iva-exemption-type.dto";

@injectable()
export class IvaExemptEnumMapper {
    map(
        ivaExemptionTypeEnumDto: IvaExemptionTypeEnumDto,
    ): Nullable<IvaExemptTypeEnum> {
        switch (ivaExemptionTypeEnumDto) {
            case IvaExemptionTypeEnumDto.yes:
                return IvaExemptTypeEnum.yes;
            case IvaExemptionTypeEnumDto.no:
                return IvaExemptTypeEnum.no;
            default:
                return null;
        }
    }

    mapToDto(
        ivaExemptTypeEnum: IvaExemptTypeEnum,
    ): IvaExemptionTypeEnumDto {
        switch (ivaExemptTypeEnum) {
            case IvaExemptTypeEnum.yes:
                return IvaExemptionTypeEnumDto.yes;
            case IvaExemptTypeEnum.no:
                return IvaExemptionTypeEnumDto.no;
        }
    }
}